import { FC, useEffect } from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { StaffPage } from "../../pages/References/StaffPage/StaffPage";
import { EmployeePage } from "../../pages/EmployeePage/EmployeePage";
import { MainLayout } from "../../layouts";
import { CategorizationPage, OkvedCodesPage } from "../../pages";
import { SignUpPage } from "../../pages/SignUpPage/SignUpPage";
import { LoginPage } from "../../pages/LoginPage/LoginPage";
import { OrganizationsPage } from "../../pages/OrganizationsPage/OrganizationsPage";
import { OrganizationPage } from "../../pages/OrganizationPage/OrganizationPage";
import Document from "../../pages/StepPages/StepFive/ViewDocuments/Document";
import { UsersPage } from "../../pages/References/UsersPage/UsersPage";
import SelectionCategories from "../../pages/StepPages/StepFive/SelectionCategories/SelectionCategories";
import { useAppDispatch } from "../../toolkit/hooks";
import { loginByToken } from "../../toolkit/profile/profile.thunks";
import ViewDocuments from "../../pages/StepPages/StepFive/ViewDocuments";
import { logout } from "../../toolkit/profile/profile.slice";
import Finish from "pages/StepPages/StepFive/Finish/Finish";
import StepTwoDotTwo from "pages/StepPages/StepTwoDotTwo";
import { Organizations } from "pages/CategorizationPage/Organizations/Organizations";
import RequireAuth from "hoc/RequireAuth";
import NewCommission from "pages/StepPages/StepOne/NewCommission";
import Commission from "pages/StepPages/StepOne/Commission";
import TypesOfOwnership from "pages/References/TypesOfOwnership";
import TypesOfObjects from "pages/References/TypesOfOobjects";
import OrganizationMarkers from "pages/References/OrganizationMarkers";
import StatusesEmployee from "pages/References/StatusesEmployee";
import AreasOfActivity from "pages/References/AreasOfActivity";
import ObjectStatuses from "pages/References/ObjectStatuses/ObjectStatuses";
import ConsequencesOfImplementation from "pages/References/ConsequencesOfImplementation";
import ThreatsReference from "pages/References/ThreatsReference";
import ReasonsForInapplicability from "pages/References/ReasonsForInapplicability";
import IndicatorsOfSignificance from "pages/References/IndicatorsOfSignificance";
import RegisterOfKapstroy from "pages/References/RegisterOfKapstroy";
import BusinessProcessRegistry from "pages/References/BusinessProcessRegistry";
import ItemBuisnesTemplate from "pages/References/BusinessProcessRegistry/ItemBuisnesTemplate";
import { DocumentsPage } from "pages/DocumentsPage/DocumentsPage";
import UserRoles from "pages/References/UsersPage/UserRoles";
import RolesSetup from "pages/RolesSetup";
import History from "pages/History";
import PageHistory from "pages/History/Page";
import StatusOkii from "pages/OrganizationPage/StatusOkii/StatusOkii";
import ThreatPattern from "../../pages/References/ThreatPattern";
import DocumentTemplates from "pages/References/DocumentTemplates/DocumentTemplates";

export const Router: FC = () => {
	const token = localStorage.getItem("token");

	const dispatch = useAppDispatch();
	useEffect(() => {
		const memorization = localStorage.getItem("memorization");
		if (token && memorization) dispatch(loginByToken(token));
		// доп проверка
		if (!memorization && token) {
			dispatch(logout());
		}
		// ddddddddddD4d@mail.ru
		// return () => {
		//     if (!memorization) dispatch(logout)
		// }
		//eslint-disable-next-line
	}, []);

	return (
		<BrowserRouter>
			<Routes>
				<Route path="login" element={<LoginPage />} />
				<Route path="registration" element={<SignUpPage />} />

				{/* <Route path="activated" element={<EmailActive />} /> */}

				<Route
					path="/"
					element={
						<RequireAuth>
							<MainLayout />
						</RequireAuth>
					}>
					{/* <Route path="authentication" element={<AuthenticationPage />} /> */}
					<Route index element={<Navigate to={"login"} replace />} />
					<Route path="organizations" element={<OrganizationsPage />}>
						<Route path="archive" element={<OrganizationsPage />} />
					</Route>
					<Route path="settings">
						<Route path={"roles"} element={<RolesSetup />} />
					</Route>
					{/* <Route path="references">
           <Route path="staff" element={<StaffPage />} />
           </Route> */}

					<Route path="documents/:condition/:organizationId" element={<DocumentsPage />}>
						<Route path=":mode" element={<DocumentsPage />}>
							<Route path=":folderId" element={<DocumentsPage />} />
						</Route>
					</Route>

					<Route path="categorization" element={<CategorizationPage />} />
					<Route path="categorization/organizations" element={<Organizations />} />
					<Route path="/categorization/organizations/:organizationId/steps" element={<CategorizationPage />} />
					<Route
						path="/categorization/organizations/:organizationId/steps/:stepId/*"
						element={<CategorizationPage />}
					/>
					<Route path="categorization/documents/:organizationId" element={<ViewDocuments />} />
					<Route
						// path="/categorization/organizations/:organizationId/steps/:stepId/info"
						path="/categorization/organizations/:organizationId/steps/:stepId/info/*"
						// path="categorizatiion/:stepId/info"
						element={<StepTwoDotTwo />}
					/>
					<Route path="categorization/documents/:organizationId/:objId/:documentId" element={<Document />} />

					<Route path="categorization/newModel/:organizationId/:objId" element={<SelectionCategories />} />

					<Route path="categorization/finish/:organizationId/:objId" element={<Finish />} />
					<Route path="history">
						<Route index element={<History />} />
						<Route path={"organization"} element={<PageHistory />}>
							<Route path={`user/:user`} element={<PageHistory />} />
							<Route path={`org/:org`} element={<PageHistory />} />
							<Route path={`org/:org/user/:user`} element={<PageHistory />} />
							<Route path={`user/:user/org/:org`} element={<PageHistory />} />
						</Route>
						<Route path={"employee"} element={<PageHistory />}>
							<Route path={`user/:user`} element={<PageHistory />} />
							<Route path={`org/:org`} element={<PageHistory />} />
							<Route path={`org/:org/user/:user`} element={<PageHistory />} />
							<Route path={`user/:user/org/:org`} element={<PageHistory />} />
						</Route>
						<Route path={"user"} element={<PageHistory />}>
							<Route path={`user/:user`} element={<PageHistory />} />
							<Route path={`org/:org`} element={<PageHistory />} />
							<Route path={`org/:org/user/:user`} element={<PageHistory />} />
							<Route path={`user/:user/org/:org`} element={<PageHistory />} />
						</Route>
						<Route path={"role"} element={<PageHistory />}>
							<Route path={`user/:user`} element={<PageHistory />} />
							<Route path={`org/:org`} element={<PageHistory />} />
							<Route path={`org/:org/user/:user`} element={<PageHistory />} />
							<Route path={`user/:user/org/:org`} element={<PageHistory />} />
						</Route>
						<Route path={"okved"} element={<PageHistory />}>
							<Route path={`user/:user`} element={<PageHistory />} />
							<Route path={`org/:org`} element={<PageHistory />} />
							<Route path={`org/:org/user/:user`} element={<PageHistory />} />
							<Route path={`user/:user/org/:org`} element={<PageHistory />} />
						</Route>
						<Route path={"activity-area"} element={<PageHistory />}>
							<Route path={`user/:user`} element={<PageHistory />} />
							<Route path={`org/:org`} element={<PageHistory />} />
							<Route path={`org/:org/user/:user`} element={<PageHistory />} />
							<Route path={`user/:user/org/:org`} element={<PageHistory />} />
						</Route>
						<Route path={"ownership"} element={<PageHistory />}>
							<Route path={`user/:user`} element={<PageHistory />} />
							<Route path={`org/:org`} element={<PageHistory />} />
							<Route path={`org/:org/user/:user`} element={<PageHistory />} />
							<Route path={`user/:user/org/:org`} element={<PageHistory />} />
						</Route>
						<Route path={"organization-document-template"} element={<PageHistory />}>
							<Route path={`user/:user`} element={<PageHistory />} />
							<Route path={`org/:org`} element={<PageHistory />} />
							<Route path={`org/:org/user/:user`} element={<PageHistory />} />
							<Route path={`user/:user/org/:org`} element={<PageHistory />} />
						</Route>
						<Route path={"person-status"} element={<PageHistory />}>
							<Route path={`user/:user`} element={<PageHistory />} />
							<Route path={`org/:org`} element={<PageHistory />} />
							<Route path={`org/:org/user/:user`} element={<PageHistory />} />
							<Route path={`user/:user/org/:org`} element={<PageHistory />} />
						</Route>
						<Route path={"construction-object"} element={<PageHistory />}>
							<Route path={`user/:user`} element={<PageHistory />} />
							<Route path={`org/:org`} element={<PageHistory />} />
							<Route path={`org/:org/user/:user`} element={<PageHistory />} />
							<Route path={`user/:user/org/:org`} element={<PageHistory />} />
						</Route>
						<Route path={"organization-marker"} element={<PageHistory />}>
							<Route path={`user/:user`} element={<PageHistory />} />
							<Route path={`org/:org`} element={<PageHistory />} />
							<Route path={`org/:org/user/:user`} element={<PageHistory />} />
							<Route path={`user/:user/org/:org`} element={<PageHistory />} />
						</Route>
						<Route path={"object-status"} element={<PageHistory />}>
							<Route path={`user/:user`} element={<PageHistory />} />
							<Route path={`org/:org`} element={<PageHistory />} />
							<Route path={`org/:org/user/:user`} element={<PageHistory />} />
							<Route path={`user/:user/org/:org`} element={<PageHistory />} />
						</Route>
						<Route path={"object-type"} element={<PageHistory />}>
							<Route path={`user/:user`} element={<PageHistory />} />
							<Route path={`org/:org`} element={<PageHistory />} />
							<Route path={`org/:org/user/:user`} element={<PageHistory />} />
							<Route path={`user/:user/org/:org`} element={<PageHistory />} />
						</Route>
						<Route path={"threat-consequence"} element={<PageHistory />}>
							<Route path={`user/:user`} element={<PageHistory />} />
							<Route path={`org/:org`} element={<PageHistory />} />
							<Route path={`org/:org/user/:user`} element={<PageHistory />} />
							<Route path={`user/:user/org/:org`} element={<PageHistory />} />
						</Route>
						<Route path={"threat"} element={<PageHistory />}>
							<Route path={`user/:user`} element={<PageHistory />} />
							<Route path={`org/:org`} element={<PageHistory />} />
							<Route path={`org/:org/user/:user`} element={<PageHistory />} />
							<Route path={`user/:user/org/:org`} element={<PageHistory />} />
						</Route>
						<Route path={"inapplicability-reason"} element={<PageHistory />}>
							<Route path={`user/:user`} element={<PageHistory />} />
							<Route path={`org/:org`} element={<PageHistory />} />
							<Route path={`org/:org/user/:user`} element={<PageHistory />} />
							<Route path={`user/:user/org/:org`} element={<PageHistory />} />
						</Route>
						<Route path={"significance-criteria"} element={<PageHistory />}>
							<Route path={`user/:user`} element={<PageHistory />} />
							<Route path={`org/:org`} element={<PageHistory />} />
							<Route path={`org/:org/user/:user`} element={<PageHistory />} />
							<Route path={`user/:user/org/:org`} element={<PageHistory />} />
						</Route>
						<Route path={"business-process-template"} element={<PageHistory />}>
							<Route path={`user/:user`} element={<PageHistory />} />
							<Route path={`org/:org`} element={<PageHistory />} />
							<Route path={`org/:org/user/:user`} element={<PageHistory />} />
							<Route path={`user/:user/org/:org`} element={<PageHistory />} />
						</Route>
						<Route path={"step-one"} element={<PageHistory />}>
							<Route path={`user/:user`} element={<PageHistory />} />
							<Route path={`org/:org`} element={<PageHistory />} />
							<Route path={`org/:org/user/:user`} element={<PageHistory />} />
							<Route path={`user/:user/org/:org`} element={<PageHistory />} />
						</Route>
						<Route path={"step-two-dot-one"} element={<PageHistory />}>
							<Route path={`user/:user`} element={<PageHistory />} />
							<Route path={`org/:org`} element={<PageHistory />} />
							<Route path={`org/:org/user/:user`} element={<PageHistory />} />
							<Route path={`user/:user/org/:org`} element={<PageHistory />} />
						</Route>
						<Route path={"step-two-dot-two"} element={<PageHistory />}>
							<Route path={`user/:user`} element={<PageHistory />} />
							<Route path={`org/:org`} element={<PageHistory />} />
							<Route path={`org/:org/user/:user`} element={<PageHistory />} />
							<Route path={`user/:user/org/:org`} element={<PageHistory />} />
						</Route>
						<Route path={"step-three"} element={<PageHistory />}>
							<Route path={`user/:user`} element={<PageHistory />} />
							<Route path={`org/:org`} element={<PageHistory />} />
							<Route path={`org/:org/user/:user`} element={<PageHistory />} />
							<Route path={`user/:user/org/:org`} element={<PageHistory />} />
						</Route>
						<Route path={"step-four-dot-one"} element={<PageHistory />}>
							<Route path={`user/:user`} element={<PageHistory />} />
							<Route path={`org/:org`} element={<PageHistory />} />
							<Route path={`org/:org/user/:user`} element={<PageHistory />} />
							<Route path={`user/:user/org/:org`} element={<PageHistory />} />
						</Route>
						<Route path={"step-four-dot-two"} element={<PageHistory />}>
							<Route path={`user/:user`} element={<PageHistory />} />
							<Route path={`org/:org`} element={<PageHistory />} />
							<Route path={`org/:org/user/:user`} element={<PageHistory />} />
							<Route path={`user/:user/org/:org`} element={<PageHistory />} />
						</Route>
						<Route path={"step-five"} element={<PageHistory />}>
							<Route path={`user/:user`} element={<PageHistory />} />
							<Route path={`org/:org`} element={<PageHistory />} />
							<Route path={`org/:org/user/:user`} element={<PageHistory />} />
							<Route path={`user/:user/org/:org`} element={<PageHistory />} />
						</Route>
						<Route path={"step-seven"} element={<PageHistory />}>
							<Route path={`user/:user`} element={<PageHistory />} />
							<Route path={`org/:org`} element={<PageHistory />} />
							<Route path={`org/:org/user/:user`} element={<PageHistory />} />
							<Route path={`user/:user/org/:org`} element={<PageHistory />} />
						</Route>
						<Route path={"docs"} element={<PageHistory />}>
							<Route path={`user/:user`} element={<PageHistory />} />
							<Route path={`org/:org`} element={<PageHistory />} />
							<Route path={`org/:org/user/:user`} element={<PageHistory />} />
							<Route path={`user/:user/org/:org`} element={<PageHistory />} />
						</Route>
						<Route path={"step-six"} element={<PageHistory />}>
							<Route path={`user/:user`} element={<PageHistory />} />
							<Route path={`org/:org`} element={<PageHistory />} />
							<Route path={`org/:org/user/:user`} element={<PageHistory />} />
							<Route path={`user/:user/org/:org`} element={<PageHistory />} />
						</Route>
						<Route path={`user/:user`} element={<PageHistory />} />
						<Route path={`org/:org`} element={<PageHistory />} />
						<Route path={`org/:org/user/:user`} element={<PageHistory />} />
						<Route path={`user/:user/org/:org`} element={<PageHistory />} />
					</Route>
					{/* {auth && <Route path="organizations/:token" element={<Organizations />} />} */}
					<Route path="organization/:organizationId" element={<OrganizationPage />} />
					<Route path="organization/:organizationId/statusOkii" element={<StatusOkii />} />
					<Route path="references">
						<Route path="threat-pattern" element={<ThreatPattern />} />
						<Route path="staff" element={<StaffPage />} />
						<Route path="staff/select" element={<StaffPage />} />

						<Route path="staff/:organizationId" element={<StaffPage />} />

						<Route path="staff/archive/:organizationId" element={<StaffPage />} />
						<Route path="staff/archive" element={<StaffPage />} />

						<Route path="users" element={<UsersPage />} />
						<Route path="users/select" element={<UsersPage />} />
						<Route path="users/:id/roles" element={<UserRoles />} />
						<Route path="users/archive" element={<UsersPage />} />

						<Route path="ownerships" element={<TypesOfOwnership />} />
						<Route path="objects" element={<TypesOfObjects />} />
						<Route path="statuses-employee" element={<StatusesEmployee />} />
						<Route path="areas-activity" element={<AreasOfActivity />} />
						<Route path="consequences_of_the_implementation_of_threats" element={<ConsequencesOfImplementation />} />
						<Route path="markers" element={<OrganizationMarkers />} />
						<Route path="reasons_for_the_inapplicability" element={<ReasonsForInapplicability />} />
						<Route path="indicators_of_significance_criteria/*" element={<IndicatorsOfSignificance />} />
						<Route path="register_of_kapstroy_objects" element={<RegisterOfKapstroy />} />
						<Route path="register_of_kapstroy_objects/archive" element={<RegisterOfKapstroy />} />
						<Route path="business_process_registry" element={<BusinessProcessRegistry />} />
						<Route path="business_process_registry/archive" element={<BusinessProcessRegistry />} />
						<Route path="business_process_registry/select" element={<BusinessProcessRegistry />} />
						<Route path="business_process_registry/:templateId" element={<ItemBuisnesTemplate />} />
						<Route path="business_process_registry/select/:templateId" element={<ItemBuisnesTemplate />} />
						<Route path="business_process_registry/archive/:templateId" element={<ItemBuisnesTemplate />} />
						<Route path="threats" element={<ThreatsReference />} />
						<Route path="document-templates" element={<DocumentTemplates />} />
						<Route path="document-templates/:org" element={<DocumentTemplates />} />
						<Route path="object-statuses" element={<ObjectStatuses />} />

						<Route path="codes" element={<OkvedCodesPage />} />
						<Route path="codes/:organizationId/edit" element={<OkvedCodesPage />} />
					</Route>

					<Route path="employee/:employeeId" element={<EmployeePage />} />
					<Route path="user/:userId" element={<EmployeePage />} />

					<Route path="commission/:organizationId/:commissionId" element={<Commission />} />

					<Route path="newCommission/:organizationId/:commissionId" element={<NewCommission />} />

					<Route path="newCommission/:organizationId" element={<NewCommission />} />

					<Route path="*" element={<Navigate replace to="/login" />} />
				</Route>
			</Routes>
		</BrowserRouter>
	);
};
